import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import { Component } from "@/decorators";
import CampanhaPontuacaoModel from "@/models/programafidelidade/campanhaPontuacaoModel";
import UsuarioModel from "@/models/usuarioModel";
import campanhaService from "@/services/campanhaService";
import { AppState } from "@/store/store";

@Component({
    components: {
        actionBarComponent,
        comboComponent,
        searchComboComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class PontuarComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    model = new CampanhaPontuacaoModel();

    campanhaOptions: Array<Object> = [];
    clientesOptions: Array<Object> = [];

    clienteId: number;

    private async loadCampanhas() {
        try {
            this.campanhaOptions = await campanhaService.comboCached(this.usuarioLogado.franquiaId);
        } catch {}
    }

    private async save() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                const sucesso = await campanhaService
                    .pontuarByCliente(this.clienteId, this.model.campanhaId, this.model.pontos)
                    .withLoading()
                    .resolveWithoutJSON();

                if (sucesso) {
                    await this.$showInclusaoUpdate(this.model.id);

                    this.clienteId = null;
                    this.model.pontos = 0;
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private async mounted() {
        return Promise.all([this.loadCampanhas()])
            .withLoading()
            .then(() => {})
            .catch(() => {});
    }
}
